import { Injectable, OnDestroy } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { TranslationObserverService } from './translation-observer.service';

@Injectable()
export class TranslationComponentObserverService implements OnDestroy {
  public constructor(
    private readonly translationObserverService: TranslationObserverService,
    private readonly translateService: TranslateService,
  ) {
    this.translationObserverService.registerTranslateService(translateService);
  }

  public ngOnDestroy(): void {
    this.translationObserverService.unregisterTranslateService(this.translateService);
  }
}
